import React from 'react'
import { Platform } from 'react-native'

import { Link as TextLink, LinkProps as TextLinkProps } from 'solito/link'

import Text, { TextProps } from '../Text'

export type LinkProps = Omit<TextLinkProps, 'replace'> & {
  sx?: TextProps['sx']
  variant?: TextProps['variant']
  lineClamp?: number
  replace?: boolean
  dataTestId?: string
}

const Link: RFC<LinkProps> = ({
  href,
  sx,
  variant,
  children,
  lineClamp = 2,
  dataTestId,
  ...rest
}) => {
  const hoverSx = Platform.select({
    web: {
      '@media (hover: hover)': {
        '&:hover': {
          color: 'secondary.dark'
        }
      }
    },
    native: {}
  })

  return (
    // @ts-ignore
    <TextLink href={href} {...rest}>
      <Text
        variant={variant}
        lineClamp={lineClamp}
        {...(!!dataTestId && { 'data-testid': dataTestId })}
        // @ts-ignore
        sx={{
          ...hoverSx,
          ...sx
        }}
      >
        {children}
      </Text>
    </TextLink>
  )
}

export default Link
